import {recordRumAction} from '../../util/datadog/datadogRum';
import {makeTrackEvent} from './makeTrackEvent';

export type TrackArtifactsEvent = {
  action:
    | 'lineage_interaction'
    | 'collection_overview_interaction'
    | 'deploy_cta_clicked';
  artifactCollectionName: string;
  artifactTypeName: string;
  entityName: string;
  projectName: string;
  additionalData?: Record<string, unknown>;
  location?: string;
  artifactCollectionID?: string;
  artifactID?: string;
  artifactType?: string;
};

const trackArtifactsInteraction = makeTrackEvent<
  TrackArtifactsEvent,
  {
    action: {
      description: 'The artifacts interaction action.';
      exampleValues: [
        'lineage_interaction',
        'collection_overview_interaction',
        'deploy_cta_clicked',
      ];
    };
    artifactCollectionName: {
      description: 'The artifact collection involved in the interaction.';
      exampleValues: ['my-collection'];
    };
    artifactTypeName: {
      description: 'The artifact type involved in the interaction.';
      exampleValues: ['model', 'dataset'];
    };
    entityName: {
      description: 'Entity owning the artifact collection.';
      exampleValues: ['<name>'];
    };
    projectName: {
      description: 'Project owning the artifact collection.';
      exampleValues: ['core-project'];
    };
    additionalData: {
      description: 'Additional contextual properties about the interaction.';
      exampleValues: [{actionDetail: 'node_clicked'; source: 'registry'}];
    };
    location: {
      description: 'UI surface that triggered the interaction.';
      exampleValues: [
        'collection_preview_menu',
        'versions_table',
        'version_header',
      ];
    };
    artifactCollectionID: {
      description: 'GraphQL id of the collection involved in the interaction.';
      exampleValues: ['QXJ0aWZhY3RDb2xsZWN0aW9uOjEyMw=='];
    };
    artifactID: {
      description: 'GraphQL id of the artifact version being deployed, when known.';
      exampleValues: ['QXJ0aWZhY3Q6NDU2'];
    };
    artifactType: {
      description: 'Artifact type name. Matches AnalyticsProperties.ArtifactType.';
      exampleValues: ['model', 'dataset'];
    };
    _description: 'Tracks user interactions in artifact-specific experiences.';
    _location: 'artifacts pages';
    _motivation: 'Understand artifact interaction patterns and key user actions.';
  }
>('Artifacts Interaction');

export function trackArtifactsEvent(eventData: TrackArtifactsEvent): void {
  trackArtifactsInteraction(eventData);
  recordRumAction(`Artifacts.${eventData.action}`, eventData);
}
